module.exports = __webpack_public_path__ + "assets/img/20220509-3.e1bdd95a.png";